module.exports = __webpack_public_path__ + "static/media/Penalty.32728925.svg";